const ui = {
  CONTENT_MAX_WIDTH: '1160px',

  // XS 320px, SM 375px, MD 640px, LG 1024px
  MQ_MD_LG: `@media (min-width: 700px)`,
  MQ_XS_SM: `@media (max-width: 699px)`,
};

export default ui;
